/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as VodDraftDefs from "./draftDefs.defs.js";

const $nsid = "place.stream.vod.getDraft";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"uri":/*#__PURE__*/ l.string()});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"draft":/*#__PURE__*/ l.ref<VodDraftDefs.DraftView>((() => VodDraftDefs.draftView) as any)});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get a single draft VOD by its ats:// URI. Only accessible by the draft's author. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["NotFound"]);

export { main };

export const $lxm = $nsid;
